"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./validate-phone-holder.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./validate-phone-holder.component");
var i3 = require("@angular/router");
var i4 = require("@angular/material/dialog");
var i5 = require("../../Services/service.service");
var styles_ValidatePhoneHolderComponent = [i0.styles];
var RenderType_ValidatePhoneHolderComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ValidatePhoneHolderComponent, data: {} });
exports.RenderType_ValidatePhoneHolderComponent = RenderType_ValidatePhoneHolderComponent;
function View_ValidatePhoneHolderComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
exports.View_ValidatePhoneHolderComponent_0 = View_ValidatePhoneHolderComponent_0;
function View_ValidatePhoneHolderComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-validate-phone-holder", [], null, null, null, View_ValidatePhoneHolderComponent_0, RenderType_ValidatePhoneHolderComponent)), i1.ɵdid(1, 4308992, null, 0, i2.ValidatePhoneHolderComponent, [i3.ActivatedRoute, i4.MatDialog, i5.MainService, i3.Router], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_ValidatePhoneHolderComponent_Host_0 = View_ValidatePhoneHolderComponent_Host_0;
var ValidatePhoneHolderComponentNgFactory = i1.ɵccf("app-validate-phone-holder", i2.ValidatePhoneHolderComponent, View_ValidatePhoneHolderComponent_Host_0, {}, {}, []);
exports.ValidatePhoneHolderComponentNgFactory = ValidatePhoneHolderComponentNgFactory;
